// Lead detail-sheet templates (JMB-147 rebuild).
//
// Each "interested in" category maps to a list of field definitions that drive
// the dynamic detail form in `components/Lead/leadDetailModal.vue`. The captured
// values are stored on the lead's `details` JSON column (keyed by `key`).
//
// To add/adjust a category's fields, edit the arrays below — no other code change
// is needed (the detail modal renders whatever is defined here). Solar / Printer
// start as a single notes field until their paper sheets are finalized.
//
// Supported field types: text | number | textarea | date | select | switch
// Field shape: { key, label, type, options?, suffix?, cols? }

export const LEAD_CATEGORIES = [
  "CCTV",
  "Laptop",
  "Desktop",
  "Solar",
  "Printer",
  "Others",
];

export const LEAD_GRADES = ["A", "B", "C"];

const YES_NO = ["Yes", "No"];

export const LEAD_CATEGORY_TEMPLATES = {
  CCTV: [
    { key: "owner_decision_maker", label: "Owner / decision-maker?", type: "select", options: YES_NO, cols: 6 },
    { key: "decision_maker_name", label: "If no — who decides?", type: "text", cols: 6 },
    { key: "cameras_count", label: "Number of cameras", type: "number", cols: 6 },
    { key: "area_to_cover", label: "…or area to cover", type: "text", cols: 6 },
    { key: "viewing", label: "Viewing", type: "select", options: ["View on cellphone", "Record only"], cols: 6 },
    { key: "internet_at_site", label: "Internet at site?", type: "select", options: YES_NO, cols: 6 },
    { key: "budget", label: "Budget", type: "number", suffix: "₱", cols: 4 },
    { key: "range_from", label: "Range given — from", type: "number", suffix: "₱", cols: 4 },
    { key: "range_to", label: "Range given — to", type: "number", suffix: "₱", cols: 4 },
    { key: "install_by", label: "Install by", type: "date", cols: 6 },
    { key: "notes", label: "Notes", type: "textarea", cols: 12 },
  ],
  Desktop: [
    { key: "address", label: "Address", type: "text", cols: 12 },
    { key: "use", label: "Use", type: "select", options: ["eskwela", "opisina", "gaming", "editing", "business"], cols: 6 },
    { key: "set_type", label: "Set", type: "select", options: ["System unit only", "Complete set (monitor, kb, mouse, AVR)"], cols: 6 },
    { key: "specs_or_brand", label: "Specs or brand asked", type: "text", cols: 12 },
    { key: "budget", label: "Budget", type: "number", suffix: "₱", cols: 6 },
    { key: "price", label: "Price offered", type: "number", suffix: "₱", cols: 6 },
    { key: "build_cpu", label: "Build — CPU", type: "text", cols: 3 },
    { key: "build_ram", label: "Build — RAM", type: "text", cols: 3 },
    { key: "build_ssd", label: "Build — SSD", type: "text", cols: 3 },
    { key: "build_gpu", label: "Build — GPU", type: "text", cols: 3 },
    { key: "parts_in_stock", label: "Parts availability", type: "select", options: ["All parts in stock", "Some to order"], cols: 6 },
    { key: "needed_by", label: "Needed by", type: "date", cols: 6 },
    { key: "downpayment_ok", label: "20% downpayment OK?", type: "select", options: YES_NO, cols: 6 },
    { key: "official_receipt", label: "Official receipt asked?", type: "select", options: ["Yes (+12% quoted)", "No"], cols: 6 },
    { key: "notes", label: "Notes", type: "textarea", cols: 12 },
  ],
  Laptop: [
    { key: "address", label: "Address", type: "text", cols: 12 },
    { key: "use", label: "Use", type: "select", options: ["eskwela", "opisina", "gaming", "editing"], cols: 6 },
    { key: "model_asked", label: "Model asked", type: "text", cols: 6 },
    { key: "in_stock", label: "Availability", type: "select", options: ["In stock", "Special order"], cols: 6 },
    { key: "budget", label: "Budget", type: "number", suffix: "₱", cols: 6 },
    { key: "unit_offered", label: "Unit offered", type: "text", cols: 6 },
    { key: "price", label: "Price offered", type: "number", suffix: "₱", cols: 6 },
    { key: "needed_by", label: "Needed by", type: "date", cols: 6 },
    { key: "downpayment_ok", label: "Downpayment OK (if special order)?", type: "select", options: YES_NO, cols: 6 },
    { key: "official_receipt", label: "Official receipt asked?", type: "select", options: ["Yes (+12% quoted)", "No"], cols: 6 },
    { key: "notes", label: "Notes", type: "textarea", cols: 12 },
  ],
  // Stubs — replace with the real paper-sheet fields when ready.
  Solar: [{ key: "notes", label: "Notes", type: "textarea", cols: 12 }],
  Printer: [{ key: "notes", label: "Notes", type: "textarea", cols: 12 }],
  Others: [{ key: "notes", label: "Notes", type: "textarea", cols: 12 }],
};

export function templateFor(category) {
  return LEAD_CATEGORY_TEMPLATES[category] || LEAD_CATEGORY_TEMPLATES.Others;
}
